module.exports = __webpack_public_path__ + "media/images/payments/dinersclub-dark-cf72afaefbb020329b34c986e0b6d656.svg";